import 'core-js/es';
import 'whatwg-fetch'; // fetch() polyfill for making API calls.

export const _Polyfill = { window: (): any => window };

export const applyPolyfills = (): void => {
    if (!_Polyfill.window().location.origin) {
        (_Polyfill.window().location as any).origin =
            _Polyfill.window().location.protocol + '//' + _Polyfill.window().location.hostname;
    }
    // requestAnimationFrame is used in ModalComponent and is not implemented in tolinos
    if (!_Polyfill.window().requestAnimationFrame) {
        _Polyfill.window().requestAnimationFrame = (cb: any): unknown => cb();
    }
};

applyPolyfills();
